import { FieldType, TableSchema } from '../types';

export const profileTableSchema: TableSchema = {
  countPerPage: 10,
  fields: [
    {
      name: 'profile.name',
      field: 'name',
      searchable: true,
      sortable: true,
      type: FieldType.Text,
      defaultSort: true,
    },
    {
      name: 'profile.code',
      field: 'code',
      searchable: true,
      sortable: true,
      type: FieldType.Text,
      defaultSort: false,
    },
    {
      name: 'profile.price',
      field: 'price',
      searchable: true,
      sortable: true,
      type: FieldType.Price,
    },
    {
      name: 'profile.weight',
      field: 'weight',
      searchable: true,
      sortable: true,
      type: FieldType.Text,
    },
  ],
};
